import { Box, Button, Text } from '@streamelements/frontend-ui';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { promisefy } from '../../../utils/promisefy';

export const Route = createFileRoute('/_authenticated/canvases/$canvasId/$sceneId/remove')({
  component: RemoveScene,
});

function RemoveScene() {
  const { sceneId } = Route.useParams();

  const removeSelectedScene = useMutation({
    mutationFn: async () => {
      return promisefy(window.host.removeScenesByIds)([sceneId]);
    },
    onSuccess: () => {
      window.host.endModalDialog(true, () => void 0);
    },
  });

  return (
    <Box css={{ padding: '1.5rem' }}>
      <Text.Heading level="5" weight="bold" css={{ m: 0, mb: '0.25rem' }}>
        Delete scene
      </Text.Heading>
      <Text.Body css={{ mb: '2rem' }}>
        Deleting this scene will remove its sources as well. <br /> This action is irreversible.
      </Text.Body>

      <Box css={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          density="compact"
          color="neutral"
          css={{ $$textIdle: '$colors$textPrimary70' }}
          onClick={() => {
            window.host.endModalDialog(false, () => void 0);
          }}
        >
          Cancel
        </Button>
        <Button
          color="error"
          variant="outlined"
          density="compact"
          disabled={removeSelectedScene.isPending}
          onClick={() => removeSelectedScene.mutate()}
        >
          Delete
        </Button>
      </Box>
    </Box>
  );
}
